import React from 'react';
import { Tooltip } from 'antd';
import { CompassOutlined } from '@ant-design/icons';

function Geolocate ({ setUserLoc }) {
  const success = ({ coords: { longitude, latitude }}) => {
    setUserLoc({
      longitude: Number(longitude),
      latitude: Number(latitude),
      showLoc: true,
    });
  }

  const error = ({code, message}) => {
    console.warn(`ERROR(${code}): ${message}`);
  };

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  const getCoordinates = () => {
    navigator.geolocation.getCurrentPosition(success, error, options);
  }

  return (
    <Tooltip title='Your location' placement='left'>
      <CompassOutlined 
        onClick={getCoordinates}
      />
    </Tooltip>
  )
}

export default Geolocate;